export const PAGE_SIZE = 10

export const MAIN_ROW_CELLS_COUNT = 4
export const MAX_ROW_CELLS_COUNT = 7



// WEBPACK FOOTER //
// ./src/constants/toolsTable.js